import { buildRows, layoutRows, blockText, type LayoutBlock } from "./pdfLayout";
import type { PageContent } from "./pdfPageContent";

/** Plain text of one page's blocks: paragraphs separated by a blank line, table rows with tabs between cells. */
export function blocksToPlainText(blocks: LayoutBlock[]): string {
  return blocks
    .map((b) => (b.kind === "paragraph" ? blockText(b).replace(/\{[A-Za-z]+\}/g, "") : b.rows.map((r) => r.map((c) => c.runs.map((x) => x.text).join("")).join("\t")).join("\n")))
    .map((t) => t.replace(/[ \t]+$/gm, "").trim())
    .filter(Boolean)
    .join("\n\n");
}

/**
 * Reading-order text of a page, from the same layout engine PDF to Word uses: a two-column page is read
 * down the first column and then the second (not line by line across both), tables keep their cells,
 * paragraphs are rebuilt, and rotated pages are read as displayed. Running headers and page numbers are
 * kept, since a person extracting text asked for what is on the page.
 */
export function pageContentToText(content: PageContent): string {
  const rows = buildRows(content.items);
  const withText = rows.filter((r) => r.segs.length);
  if (!withText.length) return "";
  const left = Math.min(...withText.map((r) => Math.min(...r.segs.map((s) => s.left))));
  const right = Math.max(...withText.map((r) => Math.max(...r.segs.map((s) => s.right))));
  return blocksToPlainText(layoutRows(rows, { left, right }));
}
